import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  invoiceNoContainer: {
    flexDirection: "row",
    marginTop: 20,
    justifyContent: "flex-end",
  },
  invoiceDateContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  invoiceDate: {
    fontSize: 12,
    fontStyle: "bold",
  },
  label: {
    width: 60,
  },
});

const InvoiceNo = ({ invoice }) => (
  <Fragment>
    <View style={styles.invoiceNoContainer}>
      {/* <Text style={styles.label}>Offer No:</Text> */}
      <Text style={styles.invoiceDate}>Offer No. {invoice.invoice_no}</Text>
    </View>
    <View style={styles.invoiceDateContainer}>
      {/* <Text style={styles.label}>Date: </Text> */}
      <Text>Date: {invoice.trans_date}</Text>
    </View>
    <View style={styles.invoiceDateContainer}>
      <Text>KvK No. 77838769</Text>
    </View>
    <View style={styles.invoiceDateContainer}>
      <Text>Mobile: 0623847001</Text>
    </View>
  </Fragment>
);

export default InvoiceNo;
